<script>
  import { mapState } from 'vuex';
  import debounce from "debounce";

  export default {
    name: "QtyButtonBase",

    props: {
      qty: {
        type: [ String, Number ],
        required: true
      },
      minQty: {
        type: [ String, Number ],
        required: false,
        default: 1
      },
      maxQty: {
        type: [ String, Number ],
        required: false,
        default: null
      },
      disableDebounce: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    emits: ['qtyChange', 'minQtyReached', 'maxQtyReached'],

    data() {
      return {
        touched: false,
        localQty: 1 //- use this for qty in local state for immediate updates in UI
      };
    },

    watch: {
      qty: { //- watch the qty for state updates to update localQty
        immediate: true,
        handler(val) {
          this.localQty = val;
        }
      }
    },

    computed: {
      ...mapState('constants', ['maxQuantity']),

      minQtyReached() {
        return this.localQty == this.minQty;
      },

      maxQtyReached() {
        if (this.maxQty) {
          return this.localQty >= this.maxQty;
        }
        return this.localQty >= this.maxQuantity;
      }
    },

    methods: {
      incrementQty() {
        this.touched = true;
        if (this.maxQtyReached) {
          this.$emit('maxQtyReached');
          this.$store.dispatch('notifyWarn', 'Please contact Customer Service for larger quantities.');
          return;
        }

        ++this.localQty;
        if (this.disableDebounce) {
          this.sendUpdate(this.localQty);
          return;
        }
        this.sendUpdateWDebounce(this.localQty);
      },

      decrementQty() {
        this.touched = true;
        if (this.minQtyReached) {
          this.$emit('minQtyReached');
          return;
        }

        --this.localQty;
        if (this.disableDebounce) {
          this.sendUpdate(this.localQty);
          return;
        }
        this.sendUpdateWDebounce(this.localQty);
      },

      //- hold the update emit if user clicks the button multiple times in short succession
      sendUpdateWDebounce: debounce(function(qty) {
        if (!qty) {
          return;
        }
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$emit('qtyChange', qty);
      }, 500),

      sendUpdate: function(qty) {
        if (!qty) {
          return;
        }
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$emit('qtyChange', qty);
      }
    }
  };
</script>
